import React from "react";
import 'chart.js/auto';
import { Pie } from "react-chartjs-2";
// import { Chart as ChartJS } from "chart.js/auto";
import ChartDataLabels from 'chartjs-plugin-datalabels';

function PieChart({ chartData, options }) {
    return <Pie data={chartData} options={options} plugins={[ChartDataLabels]} />;
}

export default PieChart;